<ng-container *transloco="let t">
    <section class="pt-10 bg-card w-full control-form">
        <!-- Header -->

        <div class="sm:flex sm:flex-wrap sm:-mx-4 pt-2 pb-2 sm:pt-2 sm:py-8 sm:px-10 ">
            <!-- Title -->
            <div class="sm:w-full px-4 md:w-1/7">
                <div class="flex items-center  whitespace-nowrap">
                    <a class="ml-1 main-color" [routerLink]="['/',entityData?.route,'all']">{{t(entityData?.name?.plural)}}</a>
                    <mat-icon class="icon-size-8 text-secondary" [svgIcon]="!override.isRTL? 'heroicons_solid:chevron-right': 'heroicons_solid:chevron-left'">
                    </mat-icon>
                </div>
                <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                    <mat-icon class="icon-size-8 relative top-1 main-color" matPrefix [svgIcon]="'mat_outline:location_city'">
                    </mat-icon>
                    <ng-container *ngIf="entityData?.isEdit == true">
                        <span>{{t('Edit')}} </span>
                        <span class="main-color font-extrabold ">{{t(entityData?.name?.single)}}  </span>
                    </ng-container>
                    <ng-container *ngIf="entityData?.isEdit == false">
                        <span>{{t('New')}} </span>
                        <span class="main-color font-extrabold ">{{t(entityData?.name?.single)}}</span>
                    </ng-container>
                </h2>
            </div>
            <!-- Action Buttons -->
            <div class="px-4 md:w-1/7  md:-mt-5 xs:mt-0 flex relative md:bottom-7 -bottom-3 actionButtons" [ngClass]="!override.isRTL? 'md:ml-auto': 'md:mr-auto'">
                <button mat-button class="main-background white-color m-auto" accesskey="s" (click)="entityData?.onSave()">
               <span >{{t('Save')}}</span>
               <!-- [disabled]="entityData?.form?.invalid" -->
                    <mat-icon class="white-color mr-1 ml-1" svgIcon="mat_outline:save"></mat-icon>
                </button>
            </div>
        </div>

        <div class="flex-wrap content-start place-content-center sm:px-10">
            <div class="row-start-1 mt-2">
                <ng-content select="[form]"></ng-content>
            </div>
        </div>
    </section>

</ng-container>